import {useLang} from '@/context/LanguageContext';
import {Checkbox} from '@/components/ui/checkbox';
import {Terminal,Clipboard} from 'lucide-react';
import {toast} from 'sonner';
// Same presentation as the existing Condition wizard; its source is unchanged.
export function CommandBlock({ children, label }) {
  const { t } = useLang();
  const copy = async () => { await navigator.clipboard.writeText(children); toast.success(t("Commando gekopieerd", "Command copied")); };
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-[#11181c] text-slate-100">
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
        <span className="flex items-center gap-2"><Terminal className="h-3.5 w-3.5" /> {label || t("Commando", "Command")}</span>
        <button onClick={copy} className="flex items-center gap-1.5 rounded px-2 py-1 text-slate-300 hover:bg-white/10 hover:text-white"><Clipboard className="h-3.5 w-3.5" /> {t("Kopiëren", "Copy")}</button>
      </div>
      <pre className="overflow-x-auto whitespace-pre-wrap p-4 font-mono text-xs leading-6">{children}</pre>
    </div>
  );
}

export function ManualCheck({ checked, onCheckedChange, children }) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-md border border-border bg-muted/15 px-3 py-2.5 text-sm hover:bg-muted/30">
      <Checkbox checked={!!checked} onCheckedChange={onCheckedChange} className="mt-0.5" />
      <span>{children}</span>
    </label>
  );
}

